const state = () => ({
  didFetchSpotifyShops: false,
  didFetchPopularShops: false,
  spotifyShops: [],
  popularShops: [],
});

const getters = {
  getSpotifyShops: (state) => {
    return state.spotifyShops;
  },
  getPopularShops: (state) => {
    return state.popularShops;
  },
  getAllShops: (state) => {
    return state.spotifyShops.concat(state.popularShops);
  },
  didFetchSpotifyShops: (state) => {
    return state.didFetchSpotifyShops;
  },
  didFetchPopularShops: (state) => {
    return state.didFetchPopularShops;
  },
};

const actions = {
  updateSpotifyShops({ commit }, shops) {
    commit("setSpotifyShops", shops);
  },
  updatePopularShops({ commit }, shops) {
    commit("setPopularShops", shops);
  },
  fetchedSpotifyShops({ commit }) {
    commit("setDidFetchSpotifyShops", true);
  },
  fetchedPopularShops({ commit }) {
    commit("setDidFetchPopularShops", true);
  },
  clearOnboardInfo({ commit }) {
    commit("clearAll");
  },
};

const mutations = {
  setSpotifyShops(state, shops) {
    state.spotifyShops = shops;
  },
  setPopularShops(state, shops) {
    state.popularShops = shops;
  },
  setDidFetchSpotifyShops(state, didFetch) {
    state.didFetchSpotifyShops = didFetch;
  },
  setDidFetchPopularShops(state, didFetch) {
    state.didFetchPopularShops = didFetch;
  },
  clearAll(state) {
    state.didFetchSpotifyShops = false;
    state.didFetchPopularShops = false;
    state.spotifyShops = [];
    state.popularShops = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
